<template>
  <div>
    <form>
      <b-form-group
        label-cols="4"
        id="firstName"
        label="First Name"
        label-for="firstName"
        :invalid-feedback="firstnameInvalidFeedback"
        :state="firstnameState"
      >
        <b-form-input
          id="firstName"
          v-on:keypress="isLetter($event)"
          v-model="firstName"
          size="sm"
          :state="firstnameState"
          trim
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols="4"
        id="lastName"
        label="Last Name"
        label-for="lastName"
        :invalid-feedback="lastnameInvalidFeedback"
        :state="lastnameState"
      >
        <b-form-input
          id="lastName"
          v-on:keypress="isLetter($event)"
          v-model="lastName"
          size="sm"
          :state="lastnameState"
          trim
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols="4"
        id="contactNumber"
        label="Contact"
        label-for="contactNumber"
        :invalid-feedback="contactInvalidFeedback"
        :state="numberState"
      >
        <b-form-input
          id="contactNumber"
          v-model="saveNumber"
          size="sm"
          :disabled="true"
          :state="numberState"
          trim
        ></b-form-input>
      </b-form-group>

      <!-- <b-form-group
        label-cols="4"
        id="externalId"
        label="External ID"
        label-for="externalId"
        :invalid-feedback="externalidInvalidFeedback"
        :state="externalidState"
      >
        <b-form-input
          id="externalId"
          type="number"
          v-model="externalId"
          size="sm"
          :state="externalidState"
          trim
        ></b-form-input>
      </b-form-group> -->

      <b-form-group
        label-cols="4"
        id="emailId"
        label="Email ID"
        label-for="emailId"
        :invalid-feedback="emailidInvalidFeedback"
        :state="emailidState"
      >
        <b-form-input
          id="emailId"
          v-model="emailId"
          size="sm"
          type="email"
          :state="emailidState"
          trim
        ></b-form-input>
      </b-form-group>

      <div class="call-handle-buttons-container">
        <b-button
          size="sm"
          pill
          @click="createNewContact()"
          :disabled="buttonStatus"
          class="call-handle-buttons"
          style="margin-left:5px"
          variant="success"
        >
          {{ buttonText }}
        </b-button>
        <b-button
          size="sm"
          pill
          @click="cancelCreateNewContact()"
          class="call-handle-buttons"
          variant="danger"
        >
          Cancel
        </b-button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import "amazon-connect-streams";
import "amazon-connect-chatjs";

export default {
  name: "SaveContact",
  components: {},
  data() {
    return {
      buttonText: "Add Contact",
      buttonStatus: false,
      firstName: "",
      lastName: "",
      externalId: "",
      emailId: "",
    };
  },
  created() {},
  mounted() {},
  methods: {
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[A-Za-z]+$/.test(char)) return true;
      // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
    createNewContact() {
      if (this.firstName.length > 4) {
        this.buttonText = "Saving";
        this.buttonStatus = true;
        var passData = {};
        passData.action = "CREATE_CONTACT";
        passData.firstName = this.firstName;
        passData.lastName = this.lastName;
        passData.contactNumber = this.saveNumber;
        passData.externalId = this.externalId;
        passData.emailId = this.emailId;
        parent.postMessage(passData, "*");
      } else {
        console.log("name length");
      }
    },
    cancelCreateNewContact() {
      this.$store.dispatch("actions/homeSubNavigation", "home");
    },
  },
  computed: {
    firstnameState() {
      return this.firstName.length >= 4 ? true : false;
    },
    lastnameState() {
      return this.lastName.length >= 4 ? true : false;
    },
    numberState() {
      return this.saveNumber.length >= 10 ? true : false;
    },
    externalidState() {
      return this.externalId.length == 8 ? true : false;
    },
    emailidState() {
      return this.emailId.length >= 8 ? true : false;
    },
    firstnameInvalidFeedback() {
      if (this.firstName.length > 4) {
        return "";
      } else if (this.firstName.length > 0) {
        return "Enter at least 4 characters";
      }
    },
    lastnameInvalidFeedback() {
      if (this.lastName.length > 4) {
        return "";
      } else if (this.lastName.length > 0) {
        return "Enter at least 4 characters";
      }
    },
    contactInvalidFeedback() {
      if (this.saveNumber.length > 10) {
        return "";
      } else if (this.saveNumber.length > 0) {
        return "Enter valid phone number";
      }
    },
    externalidInvalidFeedback() {
      if (this.externalId.length > 8) {
        return "";
      } else if (this.externalId.length > 0) {
        return "Enter valid External ID";
      }
    },
    emailidInvalidFeedback() {
      if (this.emailId.length > 8) {
        return "";
      } else if (this.emailId.length > 0) {
        return "Enter valid Email ID";
      }
    },
    ...mapGetters(["saveNumber"]),
  },
};
</script>

<style scoped>
/* .scrollbar-hidden::-webkit-scrollbar {
  display: none;
} */
/* 
Hide scrollbar for IE,
Edge add Firefox .scrollbar-hidden {
  -ms-overflow-style: none;
  scrollbar-width: none; /* Firefox */
/* } */

/* Chrome, Safari, Edge, Opera */
/* input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
*/

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

form {
  height: 430px;
  width: 99%;
  scrollbar-width: none;
  overflow-y: scroll;
  font-size: 12px;
  margin-top: 1rem;
}

form::-webkit-scrollbar {
  display: none;
}
form {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
}

.call-handle-buttons-container {
  display: flex;
  justify-content: center;
}

.call-handle-buttons {
  margin: 0 1rem;
}
</style>
